import React from "react";

const ReleaseV0 = () => {
  return (
    <div className="release_content">
      <h3>Alpha v1.0.0</h3>
      <p>Released on 29 March 2023</p>

      <h2>Landing Page</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>
            The main page which comprises of Data Catalogue where we have
            datasets in widgets form and the total figure of datasets.
          </span>
        </li>
        <li>
          <span>
            Navigation Bar which holds Global Search,Support & Services,Logged
            In User(MSAL Authenticated)
          </span>
        </li>
        <li>
          <span>
            View All Button which captures all the datasets information
          </span>
        </li>
        <li>
          <span>Search Assistant Introduced </span>
        </li>
        <li>
          <span>
            Navigation Bar will now have Catalogue Dropdown in individual pages
            for easily routing to Landing Page
          </span>
        </li>
      </ul>

      <h2>Individual Dataset Page</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>
            Meta Data Information in Column Tab including
            CountDistinct,Profiling Metrics,Validation Metrics on expansion of
            column
          </span>
        </li>
        <li>
          <span>
            Dataset Description along with the quality of dataset shown{" "}
          </span>
        </li>
        <li>
          <span>
            Dataset Profiling Metrics graph under Profiling Metrics Tab
          </span>
        </li>
        <li>
          <span>Dataset Details Popup with schema,datasource and metrics</span>
        </li>
        <li>
          <span>
            Dataset Table Quality graphical and tabular representation
          </span>
        </li>
        <li>
          <span>Lineage (POC)</span>
        </li>
        <li>
          <span>
            Dataset Utilization Bars based on User Count on daily basis & User
            Utilization by Datasets both in Tabular and graphical View
          </span>
        </li>
        <li>
          <span>
            Preview Tab showing the dataset data in tabular format from Dremio
          </span>
        </li>
      </ul>
      <h2>Global Search</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>
            Search by any keyword "customer","shipment" will go to the
            respective dataset with key word match.
          </span>
        </li>
      </ul>
      <h2>View All Datasets Page</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>
            All the Datasets information including Sensitivity,Security
            Classification details in a tabular view.
          </span>
        </li>
        <li>
          {" "}
          <span>Search Bar for searching across the table</span>
        </li>
      </ul>
      <h2>Support & Services</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>
            We have introduced a option in Navigation Bar as "Support &
            Services" which is actually a BOT to help with any queries or issues
            related to Databook application
          </span>
        </li>
      </ul>
    </div>
  );
};

export default ReleaseV0;
